import { __decorate } from "tslib";
import { field } from '@simonbackx/simple-encoding';
import { ImpersonatedBy } from './Impersonation.js';
import { MembersBlob } from './members/MemberWithRegistrationsBlob.js';
import { User } from './User.js';
export class UserWithMembers extends User {
    members = MembersBlob.create({});
    /**
     * Only set on the user of the current session, and only when that session is
     * impersonating: this user is the one being viewed, the account below is the one
     * actually acting.
     */
    impersonatedBy = null;
}
__decorate([
    field({ decoder: MembersBlob })
], UserWithMembers.prototype, "members", void 0);
__decorate([
    field({ decoder: ImpersonatedBy, nullable: true, version: 412 })
], UserWithMembers.prototype, "impersonatedBy", void 0);
//# sourceMappingURL=UserWithMembers.js.map